import React from "react";
import styled from "styled-components";
import { BsLayoutSidebar } from "react-icons/bs";
import { useAuth } from "../../hooks/useAuth.jsx";
import { Link } from "react-router-dom";
import { RiDashboardHorizontalFill } from "react-icons/ri";
import { FaCartShopping } from "react-icons/fa6";
import { PiArmchairFill } from "react-icons/pi";
import { BiSolidPrinter } from "react-icons/bi";
import { IoDocumentText, IoLogOut } from "react-icons/io5";

const menuPages = [
  {
    name: "Dashboard",
    url: "",
    icon: <RiDashboardHorizontalFill />,
  },
  {
    name: "Imprimante",
    url: "printer/0",
    icon: <BiSolidPrinter />,
  },
  {
    name: "Produse",
    url: "/backoffice/category",
    icon: <PiArmchairFill />,
  },

  {
    name: "Comenzi",
    url: "/backoffice/orders",
    icon: <FaCartShopping />,
  },

  {
    name: "Facturi",
    url: "/backoffice/invoices",
    icon: <IoDocumentText />,
  },
];

const Logo = styled.img`
  width: 7rem;
  height: auto;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 6rem;
  }

  @media (max-width: 400px) {
    width: 7rem;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding-bottom: 1.5rem;

  button {
    margin-top: 2px;
    justify-content: center;
    display: flex;
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 1.2rem;
    color: var(--secondary-font-color);
  }
`;
const LogoContainer = styled(Link)``;
const MenuWrapper = styled.div<{ $showMenu: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: white;
  justify-content: space-between;
  width: 165px;
  padding: 20px;
  color: var(--tertiary-font-color);
  border-right: 2px solid #f2f2f2;

  transition: transform 0.3s ease-in-out;
  transform: ${({ $showMenu }) =>
    $showMenu ? "translateX(0)" : "translateX(-160px)"};
  position: relative;
  z-index: 100;
`;

const MenuContainer = styled.div`
  color: var(--tertiary-font-color);
  display: flex;
  flex-direction: column;
`;

const MenuItem = styled(Link)<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.$isActive ? "var(--primary-green)" : "var(--primary-font-color)"};

  font-size: 1rem;
  font-family: Verdana, sans-serif;
  cursor: pointer;
  text-decoration: none;
  padding: 10px;
  border-radius: 4px;
  gap: 8px;
  background-color: ${(props) =>
    props.$isActive ? "var(--background-green)" : "transparent"};

  svg {
    font-size: 1.2rem;
  }
`;

const Logout = styled.button`
  display: flex;
  align-items: center;
  color: var(--primary-font-color);
  background-color: white;
  border: none;
  padding: 0.5rem;
  display: flex;
  gap: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-family: Verdana, sans-serif;

  svg {
    font-size: 1.2rem;
  }
`;

interface InputFieldProps {
  toggleMenu: (state: boolean) => void;
}

const DashboardSidebarMenu: React.FC<InputFieldProps> = ({ toggleMenu }) => {
  const { logout } = useAuth();
  const [activeTab, setActivetab] = React.useState(-1);
  const [showMenu, setShowMenu] = React.useState(true);

  return (
    <MenuWrapper $showMenu={showMenu} data-testid="sidebar-menu">
      <MenuContainer>
        <HeaderContainer>
          <LogoContainer to="/">
            <Logo src={"/images/longLogo.png"} alt="Logo" />
          </LogoContainer>

          <button
            style={{ marginRight: "-14px" }}
            onClick={() => {
              setShowMenu((prev) => !prev);
              toggleMenu(showMenu);
            }}
          >
            <BsLayoutSidebar />
          </button>
        </HeaderContainer>

        {showMenu &&
          menuPages.map((page, index) => (
            <MenuItem
              $isActive={index === activeTab}
              key={page.name}
              to={page.url}
              onClick={() => setActivetab(index)}
            >
              {page.icon} {page.name}
            </MenuItem>
          ))}
      </MenuContainer>

      <Logout
        onClick={() => {
          logout();
        }}
      >
        <IoLogOut /> Logout
      </Logout>
    </MenuWrapper>
  );
};

export default DashboardSidebarMenu;
